(ns frontend.domain.sales-opportunity.actions
  (:require
   [frontend.actions.sales-opportunity :as sales-opportunity-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.zap-time :as zap-time]))

(defn resurrect!
  [entity]
  (sales-opportunity-actions/*->resurrect!
   {:sales-opportunity-id (:db/id entity)}
   (fn [_])
   (fn [err]
     (logging/error "Failed to reactivate froppo " err))))

(defn agreement-start-value
  [entity]
  (let [fo-owner (:sales-opportunity/owner entity)
        fo-credit (:sales-opportunity/credit entity)]
    (merge
     {:sale-agreement/owner    (or (session/active-account-id fo-owner)
                                   (:db/id @session/account))
      :sale-agreement/customer (:sales-opportunity/customer entity)}
     (when (f-permissions/field-write-access? :sale-agreement/won-by
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/won-by (or (session/active-account-id fo-credit)
                                   (session/active-account-id fo-owner)
                                   (:db/id @session/account))})
     (when (f-permissions/field-write-access? :sale-agreement/credit
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/credit (or (session/active-account-id fo-credit)
                                   (session/active-account-id fo-owner)
                                   (:db/id @session/account))})
     (when (f-permissions/field-write-access? :sale-agreement/cur-committed-amount
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/cur-committed-amount
        (or (:sales-opportunity/cur-estimated-ARR entity)
            (:sales-opportunity/cur-offered-price entity))
        :sale-agreement/cur-committed-amount--sym
        (or (:sales-opportunity/cur-estimated-ARR--sym entity)
            (:sales-opportunity/cur-offered-price--sym entity))})
     (when (f-permissions/field-write-access? :sale-agreement/committed-date
                                              :entity.type/sale-agreement
                                              nil)
       {:sale-agreement/committed-date (zap-time/now)})
     (when-let [target (:sales-opportunity/offered-asset entity)]
       (when (f-permissions/field-write-access? :sale-agreement/sale-target
                                                :entity.type/sale-agreement
                                                nil)
         {:sale-agreement/sale-target target})))))
